import { render, staticRenderFns } from "./get-prize-dialog.vue?vue&type=template&id=54cde902&scoped=true&"
import script from "./get-prize-dialog.vue?vue&type=script&setup=true&lang=ts&"
export * from "./get-prize-dialog.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./get-prize-dialog.vue?vue&type=style&index=0&id=54cde902&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cde902",
  null
  
)

export default component.exports